import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const formatTime = (seconds) => {
  if (seconds == null || seconds < 0) return '--:--';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

const SessionTimer = ({ secondsRemaining, warning }) => {
  return (
    <Box
      sx={{
        px: 2,
        py: 0.5,
        borderRadius: 1,
        bgcolor: warning === '1min' ? 'error.light' : warning === '5min' ? 'warning.light' : 'grey.100',
        animation: warning ? 'pulse 2s ease-in-out infinite' : 'none',
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.7 },
        },
      }}
    >
      <Typography
        variant="h5"
        fontFamily="monospace"
        fontWeight={700}
        color={
          warning === '1min' ? 'error.main'
            : warning === '5min' ? 'warning.main'
              : 'text.primary'
        }
      >
        {secondsRemaining <= 0 ? 'TIME' : formatTime(secondsRemaining)}
      </Typography>
    </Box>
  );
};

export default SessionTimer;
